// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mark-list .select-ohif-label {\r\n  width: 80px;\r\n  display: inline-block;\r\n}\r\n\r\n.action {\r\n    background: none;\r\n    text-align: right;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
